/**
 * @file
 * Sticky main navigation.
 */
/* eslint-disable-next-line import/no-extraneous-dependencies */
import _ from "lodash";
import ResizeSensor from "resize-sensor";
import StickySidebar from "sticky-sidebar";

const breakpoint = window.breakpoints;
const options = window.mainNavOptions;

(() => {
  /**
   * Sticks or detaches the header.
   *
   * @param {onWindowResizeAndLoad~requestCallback} cb
   *   The callback that handles the response.
   * @param {number} debounceTime
   *   Duration after which the function is run.
   */
  function onWindowResizeAndLoad(cb, debounceTime = 100) {
    window.addEventListener(
      "resize",
      _.debounce(() => {
        cb();
      }, debounceTime)
    );
    cb();
  }

  /**
   * Initializes sticky header.
   */
  function init() {
    const siteHeader = document.querySelector(".js-header");
    const siteHeaderInner = document.querySelector(".js-header__inner");
    /* eslint-disable no-unused-vars */

    onWindowResizeAndLoad(() => {
      if (window.matchMedia(breakpoint.large).matches) {
        const stickySidebar = new StickySidebar(siteHeader, options);
      } else {
        const stickySidebar = new StickySidebar(siteHeader, options);
        stickySidebar.destroy();
      }

      function cb() {
        if (window.matchMedia(breakpoint.large).matches) {
          const stickySidebar = new StickySidebar(siteHeader, options);
          stickySidebar.updateSticky();
        }
      }

      const navbarSensor = new ResizeSensor(siteHeaderInner, cb);
    });
  }

  init();
})();
